import { Card, CardBody, CardTitle, Spinner } from 'reactstrap'
import '../style.css'
import { useSelector } from 'react-redux'
import Loader from 'views/pages/Loader'
import AxiosInstance from 'utils/AxiosInstance'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { setCompletedCoursesData } from 'store/Dashboard/actions'
import { setCompletedCoursesFetched } from 'store/Dashboard/actions'
import { fetchUserProgress } from 'store/Course/actions'
function CoursesCompleted() {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}
  const courses = useSelector((state) => state.courses)

  const dispatch = useDispatch()
  const {
    coursesCompletedFetched,
    coursesCompletedData: { allCompletedCourses, loading },
  } = useSelector((state) => state.dashboard)

  const getCompletedCourses = async () => {
    try {
      dispatch(setCompletedCoursesData({ loading: true }))
      const completed = courses?.userProgress?.filter(
        (course) => course?.status === 4
      )
      // dispatch(setCompletedCoursesFetched(true))

      const noDuplicateCompletedCourses = completed.filter(
        (item, index) =>
          index ===
          completed.findIndex((elem) => elem.course_id === item.course_id)
      )
      dispatch(
        setCompletedCoursesData({
          allCompletedCourses: noDuplicateCompletedCourses,
        })
      )

      if (noDuplicateCompletedCourses) {
        dispatch(
          setCompletedCoursesData({
            completedCourses: noDuplicateCompletedCourses.length,
          })
        )
      }
      // dispatch(setCompletedCoursesData({ loading: false }))
    } catch (e) {
      console.log(e, 'error')
    }
  }

  useEffect(() => {
    if (coursesCompletedFetched) return
    getCompletedCourses()
  }, [coursesCompletedFetched, courses?.userProgress?.length])

  const activeCourses = courses.courses.filter(
    (course) => course.is_active == 1
  )

  const completdCoursesActive =
    allCompletedCourses &&
    allCompletedCourses.length &&
    allCompletedCourses.filter((course) =>
      courses.courses.find(
        (courseAll) => courseAll.course_id == course.course_id
      )
    )

  const percentage =
    completdCoursesActive.length && activeCourses.length > 0
      ? (completdCoursesActive.length / activeCourses.length) * 100
      : '0'

  // let remainingCourses =
  //   courses.courses.length -
  //   (completdCoursesActive ? completdCoursesActive.length : 0)

  // let stroke = remainingCourses === 0 ? 0 : 180 / remainingCourses
  let stroke =
    activeCourses.length - completdCoursesActive.length === 0 ||
    isNaN(activeCourses.length - completdCoursesActive.length)
      ? 141.392
      : 141.392 *
        ((activeCourses.length - completdCoursesActive.length) /
          activeCourses.length)

  if (parseInt(percentage) > 100) {
    stroke = 0
  }

  return (
    <Card className='p-2' style={{ minHeight: '228px' }}>
      {/* <div  style={{ maxHeight: '212px', marginBottom: '0px' }}> */}
      {window.location.href.includes('wingsnob') ||
      window.location.href.includes('localhost') ? (
        <CardTitle className='h2 mb-0 ml-3 mt-3'>My Personal Score</CardTitle>
      ) : null}

      {loading ? (
        <div
          className='text-center'
          style={{ marginTop: 'auto', marginBottom: 'auto' }}
        >
          <Loader color='default' />
        </div>
      ) : (
        <div style={{ maxHeight: '212px', marginBottom: '0px' }}>
          <div className='progress-bar-wrapper d-flex flex-column justify-content-center align-items-center '>
            <div className='mt-0'>
              <svg viewBox='0 0 100 50'>
                <path
                  d='M 50,50 m -45,0 a 45,45 0 1 1 90,0'
                  stroke='#dedede'
                  strokeWidth='10'
                  fillOpacity='0'
                  strokeLinecap='round'
                ></path>
                <path
                  d='M 50,50 m -45,0 a 45,45 0 1 1 90,0'
                  stroke='#5bc0de'
                  strokeWidth='10'
                  fillOpacity='0'
                  strokeLinecap='round'
                  style={{
                    strokeDasharray: '141.392, 141.392',
                    strokeDashoffset: stroke,
                  }}
                ></path>
              </svg>
            </div>
            <div>
              {percentage ? (
                <div className='progress-bar-text'>
                  {parseInt(percentage) > 100 ? 100 : parseInt(percentage)}%{' '}
                  <p className='completed'>
                    {language.general ? language.general.completed : null}
                  </p>
                </div>
              ) : (
                <div className='progress-bar-text font-weight-normal text-sm'>
                  <Loader type='grow' color='info' />
                  <p className='completed'>
                    {language.general ? language.general.completed : null}
                  </p>{' '}
                </div>
              )}
              {/* <div className='progress-bar-text'>
							{props.loading
								? '...'
								: props.percentage !== undefined ||
								  props.percentage !== '' ||
								  props.percentage !== NaN
								? parseInt(props.percentage)
								: '0'}
							% <p className='completed'>Completed</p>
						</div> */}

              <div className='text-center'>
                <p>
                  {language.general ? language.general.yiur_total_points : null}{' '}
                  {completdCoursesActive.length
                    ? completdCoursesActive.length
                    : '0'}
                  /{courses.courses ? activeCourses.length : '0'}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  )
}

export default CoursesCompleted
